import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceTemplate.css';

function FYOUWorkshops() {
  return (
    <div className="service-page">
      <section className="service-hero" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/ihv79jey_tim_speaker%20%281%29.jpeg)`, backgroundPosition: 'center 20%'}}>
        <div className="container">
          <h1>The <span className="fit-inline"><span className="f-blue">F</span>-YOU</span> Workshops</h1>
          <p style={{color: '#FF6B35', fontSize: '1.1em', marginBottom: '10px', fontWeight: '500', fontStyle: 'italic'}}>Born from lived experience, built on psychology, driven by passion</p>
          <p className="subtitle">Building a positive culture, preventing workplace disengagement</p>
        </div>
      </section>

      {/* White section with F-YOU logo repeating pattern - placed outside service-content */}
      <div style={{
        width: '100%', 
        padding: '60px 20px', 
        position: 'relative',
        background: `
          linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)),
          url(/fyou-logo-edit.jpeg)
        `,
        backgroundSize: 'auto, 100px 100px',
        backgroundRepeat: 'no-repeat, repeat',
        backgroundPosition: '0 0, 0 0'
      }}>
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>From Individual Wellbeing to Organisational Culture</h2>
          <p>You can communicate with someone who has a high F-IT score - a person struggling with their wellbeing who's approaching dangerous decision-making. But it's nearly impossible to communicate with someone who has a high F-YOU score.</p>
          <p>When an individual with high F-IT receives poor organisational response - being dismissed, ignored, or unsupported - it transforms into F-YOU. That's when personal wellbeing crisis becomes organisational disengagement, and that's where the real damage happens.</p>
          <p style={{marginBottom: 0}}><strong>A cluster of people with high F-YOU scores is the definition of a toxic culture.</strong></p>
        </div>
      </div>

      {/* Full-width light grey section - What F-YOU Really Costs */}
      <div style={{backgroundColor: '#f9f9f9', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>What F-YOU Really Costs</h2>
          <p>The F-YOU mindset directly impacts your bottom line through:</p>
          <ul>
            <li><strong>Turnover:</strong> Disengaged employees leave, costing £3,000-£30,000 per replacement</li>
            <li><strong>Absenteeism:</strong> People avoid a workplace where they feel dismissed or undervalued</li>
            <li><strong>Presenteeism:</strong> Physically present but mentally checked out - contributing to the £24 billion annual cost</li>
            <li><strong>Lost Discretionary Effort:</strong> Employees do the bare minimum, nothing extra</li>
            <li><strong>Accidents & Incidents:</strong> Disengaged workers are more likely to make dangerous decisions</li>
            <li><strong>Spurious Claims:</strong> A "F-YOU" mindset increases grievances and compensation claims</li>
          </ul>
        </div>
      </div>

      {/* Full-width light grey section - The Solution */}
      <div style={{backgroundColor: '#f2f2f2', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>The Solution: Strategic Culture Creation</h2>
          <p>Since you can't directly communicate with people who have high F-YOU scores, the answer isn't more "engagement initiatives" or wellbeing campaigns. The answer is <strong>strategically and coordinately creating a positive culture built on respect, value, and integrity</strong> that prevents F-YOU from developing in the first place.</p>
          <p>This isn't theory - it's proven methodology from Anker & Marsh, award-winning pioneers in holistic, integrated, practical approaches to human error risk management and workplace culture.</p>
        </div>
      </div>

      {/* Full-width light grey section - shade 2 (Workshop Formats header) */}
      <div style={{backgroundColor: '#ebebeb', width: '100%', padding: '100px 20px 80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'center'}}>
            <div>
              <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Workshop Formats</h2>
              <p>We offer bespoke workshops tailored to your audience and organisational needs - from introductory sessions for senior leadership to comprehensive hands-on training for front-line managers.</p>
            </div>
            <div style={{textAlign: 'center'}}>
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80" alt="Small group workshop discussion around table" style={{maxWidth: '100%', height: 'auto', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)'}} />
            </div>
          </div>
        </div>
      </div>

      {/* Continuation of same grey section - Introductory Session */}
      <div style={{backgroundColor: '#ebebeb', width: '100%', padding: '0px 20px 80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Introductory Session: F-YOU Workshop for Senior Management</h2>
            <p><strong>The perfect starting point - strategic focus on principles and methodological options for building strong culture</strong></p>
          
          <h3>What's Covered:</h3>
          <ul>
            <li>Understanding the F-IT to F-YOU transformation and its organisational impact</li>
            <li>The two classic mistakes organisations make in culture creation</li>
            <li>Why some organisations get little return on training investment while others achieve wonderful returns</li>
            <li>Methodological options for building a strong culture and reducing F-YOU mindset</li>
            <li>Strategic approaches to genuine learning culture</li>
            <li>Closing strategy options and recommendations specific to your organisation</li>
          </ul>

          <h3>Format:</h3>
          <ul>
            <li><strong>Duration:</strong> Half-day (2 hours) - two 55-minute sessions with 10-minute break</li>
            <li><strong>Facilitator:</strong> Prof. Tim Marsh</li>
            <li><strong>Basis:</strong> Following culture survey, desktop review, key interviews, or consultation with stakeholders</li>
          </ul>

          <h3>Perfect For:</h3>
          <ul>
            <li>Board members and executive leadership</li>
            <li>Senior management teams</li>
            <li>Directors of HR, Health & Safety, Operations</li>
            <li>Anyone responsible for organisational strategy and culture</li>
          </ul>
        </div>
      </div>

      {/* White section */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>2. F-YOU Orientation for Front-Line Management & Supervisors</h2>
          <p><strong>2-hour awareness session covering the basics - perfect for larger audiences</strong></p>
          
          <h3>What's Covered:</h3>
          <p>This orientation session provides an introduction to the F-YOU mindset and the basics of what front-line managers need to know to create positive culture. More awareness-focused than deep training, it's designed to reach larger audiences who need foundational understanding.</p>
          
          <ul>
            <li>Understanding the F-IT to F-YOU transformation at team level</li>
            <li>How organisational response impacts individual wellbeing and engagement</li>
            <li>Basic principles of building positive culture day-to-day</li>
            <li>Introduction to emotional intelligence concepts</li>
            <li>Overview of key tools and behaviours that make a difference</li>
          </ul>

          <h3>Format:</h3>
          <ul>
            <li><strong>Duration:</strong> 2 hours</li>
            <li><strong>Audience Size:</strong> Suitable for larger groups (not limited to 6-12)</li>
            <li><strong>Nature:</strong> Awareness and orientation, not hands-on training</li>
            <li><strong>Perfect as:</strong> Introduction before committing to full 2-day training</li>
          </ul>

          <h3>Perfect For:</h3>
          <ul>
            <li>Organisations wanting to introduce F-YOU concepts to a wide audience</li>
            <li>Front-line managers exploring whether the full 2-day training is right for them</li>
            <li>Creating baseline awareness across multiple teams or departments</li>
            <li>Budget-conscious organisations wanting to start with foundation awareness</li>
          </ul>
        </div>
      </div>

      {/* Full-width light grey section - shade 3 */}
      <div style={{backgroundColor: '#f2f2f2', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>3. F-YOU Full Training for Front-Line Management & Supervisors</h2>
          <p><strong>Comprehensive hands-on training in the day-to-day behaviours that create positive culture</strong></p>
          
          <h3>What's Covered:</h3>
          <ul>
            <li><strong>Building a Genuine Learning Culture:</strong> Key reactive and proactive questions leaders should ask regularly, and how to act on the answers</li>
            <li><strong>Emotional Intelligence Skills:</strong>
              <ul>
                <li>Appropriate praise (20x more effective than criticism in changing behaviour)</li>
                <li>Constructive negative feedback</li>
                <li>Active listening</li>
                <li>Coaching and delegating</li>
                <li>Assertion skills</li>
              </ul>
            </li>
            <li><strong>Understanding Individual Differences:</strong> Tailoring tasks and communication to maximise individual output</li>
            <li><strong>Practical Tools:</strong>
              <ul>
                <li>Five Whys technique</li>
                <li>ABC analysis</li>
                <li>High-value questions</li>
                <li>Mental health awareness and conversations</li>
              </ul>
            </li>
            <li><strong>Excellence Theory:</strong> Context for why these behaviours matter</li>
          </ul>

          <h3>Format:</h3>
          <ul>
            <li><strong>Duration:</strong> Two days (sessions do not need to be concurrent)</li>
            <li><strong>Group Size:</strong> 6-12 people for optimal interaction</li>
            <li><strong>Nature:</strong> Hands-on training, not lecture-based</li>
            <li><strong>Facilitator Options:</strong> Prof. Tim Marsh or Senior Consultant</li>
          </ul>

          <h3>Perfect For:</h3>
          <ul>
            <li>Front-line managers and supervisors</li>
            <li>Team leaders</li>
            <li>Anyone responsible for direct reports and day-to-day team culture</li>
          </ul>
        </div>
      </div>

      {/* White section with image */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'center'}}>
            <div style={{textAlign: 'center'}}>
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=80" alt="Professional team smiling together" style={{maxWidth: '100%', height: 'auto', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)'}} />
            </div>
            <div>
              <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Why These Workshops Work</h2>
          <ul>
            <li><strong>Based on Real Experience:</strong> Not corporate theory - practical methodology proven across industries</li>
            <li><strong>Holistic & Integrated:</strong> Covers mental health, safety, wellbeing, and human error together</li>
            <li><strong>Resonant Language:</strong> "Down and dirty" communication that lands with impact</li>
            <li><strong>Bespoke Approach:</strong> Tailored to your organisation's specific challenges and culture</li>
            <li><strong>Win:Win Focus:</strong> Creates benefits for both individuals and organisation</li>
            <li><strong>Automatic Coverage:</strong> Incorporates "Psychological Safety" and "Safety Differently" principles organically</li>
          </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Full-width light grey section - shade 4 */}
      <div style={{backgroundColor: '#e8e8e8', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>The Three Pillars of Culture Excellence</h2>
          
          <h3>1. Habits of a Genuine Learning Culture</h3>
          <p>Leadership regularly asks key reactive and proactive questions. Senior management commits to act on answers, especially "high impact, low cost" findings. Appropriate two-way dialogue about "high impact, high cost" issues.</p>

          <h3>2. Emotional Intelligence at Every Level</h3>
          <p>Managers and supervisors understand that appropriate praise is 20 times more effective than criticism. They have practical tools to give negative feedback constructively, listen actively, coach effectively, and delegate appropriately.</p>

          <h3>3. Understanding Individual Differences</h3>
          <p>Recognition that people need different amounts of communication - but everyone deserves quality communication. Tasks and roles tailored to maximise individual strengths rather than forcing people into ill-fitting positions.</p>
        </div>
      </div>

      {/* Pricing section */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
          <h3>Investment</h3>
          
          <p><strong>Introductory Session - Senior Management Workshop (Half-Day):</strong></p>
          <p>£2,995 plus expenses and VAT</p>
          <p><em>2 hours: two 55-minute sessions with 10-minute break</em></p>
          <p><em>Facilitator: Prof. Tim Marsh</em></p>
          <p><em>Includes closing strategy options and recommendations (following culture survey, desktop review and key interviews, or consultation with stakeholders)</em></p>
          
          <p style={{marginTop: '20px'}}><strong>F-YOU Orientation - Front-Line Management (2 Hours):</strong></p>
          <p>Contact for pricing</p>
          <p><em>Suitable for larger audiences - awareness and foundation building</em></p>
          
          <p style={{marginTop: '20px'}}><strong>F-YOU Full Training - Front-Line Management (2 Days):</strong></p>
          <p><strong>Prof. Tim Marsh:</strong> £4,990 (£2,495/day) plus expenses and VAT</p>
          <p><strong>Senior Consultant:</strong> £1,995/day plus expenses and VAT</p>
          <p><em>Groups of 6-12 participants - hands-on training</em></p>
          
          <p style={{marginTop: '20px', fontSize: '14px', fontStyle: 'italic'}}>Pricing includes bespoke tailoring to your organisation following consultation</p>
        </div>
      </div>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Build a Positive Culture?</h2>
          <p>Transform organisational response and prevent the F-IT to F-YOU&nbsp;transformation</p>
          <div style={{display: 'flex', gap: '30px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '30px'}}>
            <div style={{backgroundColor: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '8px', textAlign: 'center', minWidth: '250px'}}>
              <h3 style={{color: '#FF6B35', marginBottom: '10px'}}>Book a Consultation</h3>
              <p style={{fontSize: '14px', marginBottom: '15px'}}>Discuss your organisation's needs with our team</p>
              <Link to="/contact" className="cta-btn cta-btn-primary">Get In Touch</Link>
            </div>
            <div style={{backgroundColor: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '8px', textAlign: 'center', minWidth: '250px'}}>
              <h3 style={{color: '#FF6B35', marginBottom: '10px'}}>Explore Services</h3>
              <p style={{fontSize: '14px', marginBottom: '15px'}}>See our full range of workshops and training</p>
              <Link to="/how-it-works" className="cta-btn cta-btn-secondary">View All Services</Link>
            </div>
          </div>
          <div style={{marginTop: '30px', fontSize: '15px'}}>
            <p style={{margin: '5px 0'}}>01636 550190 option 5 <span style={{fontSize: '13px', opacity: '0.8'}}>(Mon-Fri 9am-5pm)</span></p>
            <p style={{margin: '5px 0'}}>hello@f-itscore.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FYOUWorkshops;
